import imageData from "../image.json";
import testAttemptApi from "../../api/testAttemptApi";
import * as consts from "../constants";

const state = {
  testAttemptDetails: {
    testAttemptId: 0,
    testName: "",
    totalQuestions: 0,
    currentQuestion: 0,
    result: "",
    passingScore: 0,
  },
  questionDetails: {
    questionText:
      "In a passenger vehicle which of the following must use safety belts?",
    answers: [
      {
        key: "A",
        text:
          "A.  All passengers occupying a seat in a vehicle equipped with a safety belt.",
      },
      {
        key: "B",
        text:
          "B.  The driver, front seat passenger and back seat passengers under 17 years of age.",
      },
      { key: "C", text: "C.  Only the driver." },
      { key: "D", text: "D.  Only the front seat passengers." },
    ],
    image: imageData.image,
    audio: imageData.audio,
    asl: imageData.video,
  },
  currentQuestionNumber: 1,
  testStage: 1,
  termAgreed: false,
  testInstructionsDisplayed: false,
  testStatuses: {
    NOT_STARTED: "N",
    IN_PROGRESS: "P",
    CANCELLED: "C",
    SUSPENDED: "S",
    FINISHED: "F",
  },
};

const getters = {
  testAttemptDetails(state) {
    return state.testAttemptDetails;
  },
  questionDetails(state) {
    return state.questionDetails;
  },
  testInstructionsDisplayed(state) {
    return state.testInstructionsDisplayed;
  },
};

const mutations = {
  SET_TEST_ATTEMPT(state, testAttempt) {
    state.testAttemptDetails = testAttempt;
    if (state.testAttemptDetails.currentQuestionId) {
      state.testAttemptDetails.currentQuestionId++;
    } else {
      state.testAttemptDetails.currentQuestionId = 1;
    }
  },
  SET_QUESTION_DETAILS(state, questionDetails) {
    state.questionDetails = questionDetails;
  },
  INCREMENT_QUESTION_NUMBER(state) {
    state.testAttemptDetails.currentQuestionId++;
  },
  SET_QUESTION_NUMBER(state, questionNumber) {
    state.testAttemptDetails.currentQuestionId = questionNumber;
  },
  SET_TEST_INSTRUCTIONS_DISPLAYED(state, testInstructionsDisplayed) {
    state.testInstructionsDisplayed = testInstructionsDisplayed;
  },
};

/**Helper Functions */
function determineStartPage(testStage, pages) {
  let nextPage = pages.TestInstructions.name;
  switch (testStage) {
    case consts.TEST_STAGES.TEST_QUESTIONS:
    case consts.TEST_STAGES.SKIPPED_QUESTIONS:
      nextPage = pages.Test.name;
      break;
    case consts.TEST_STAGES.INSTRUCTIONS:
      nextPage = pages.TestInstructions.name;
      break;
    case consts.TEST_STAGES.PRACTICE:
      nextPage = pages.PracticeTest.name;
      break;
  }

  return nextPage;
}
async function startTest(testAttempts, kioskSerialNumber, localeId) {
  //Sort Tests by Test Order
  const sortedTestAttempts = testAttempts.sort((a, b) => {
    return a.testOrder - b.testOrder;
  });

  //Start in-progress tests first when restarting a test//
  let testAttempt = sortedTestAttempts.find(
    (t) => t.status == consts.TEST_STATUSES.PROGRESSING
  );

  if (!testAttempt) {
    testAttempt = sortedTestAttempts.find(
      (t) => t.status !== consts.TEST_STATUSES.COMPLETE
    );
  }

  const testAttemptDetails = await testAttemptApi.initializeTest(
    testAttempt.testAttemptId,
    kioskSerialNumber,
    localeId
  );

  return testAttemptDetails;
}

const actions = {
  async startTest({ commit, getters, dispatch }) {
    dispatch("setBusy");

    const testAttemptDetails = await startTest(
      getters.testAttempts,
      getters.kioskSerialNumber,
      getters.userSession.currentLocaleId
    );

    dispatch("clearBusy");
    commit("SET_TEST_ATTEMPT", testAttemptDetails);
    return testAttemptDetails;
  },
  async getQuestion({ commit, getters, dispatch }, questionNumber) {
    dispatch("setBusy");
    const questionDetails = await testAttemptApi.getQuestion(
      getters.testAttemptDetails.testAttemptId,
      questionNumber,
      getters.selectedLocaleId
    );
    console.log(questionDetails);
    commit("SET_QUESTION_DETAILS", questionDetails);
    //dispatch("clearBusy");
  },
  async saveAnswer({ getters, dispatch }, answers) {
    dispatch("setBusy");
    const answerResult = await testAttemptApi.saveAnswer(
      getters.testAttemptDetails.testAttemptId,
      getters.testAttemptDetails.currentQuestionId,
      answers,
      getters.questionDetails.getQuestionTime,
      getters.questionDetails.isSkipped
    );
    dispatch("clearBusy");
    return answerResult;
  },
  incrementQuestionNumber({ commit }) {
    commit("INCREMENT_QUESTION_NUMBER");
  },
  async skipQuestion({ getters, dispatch }) {
    dispatch("setBusy");
    var skipQuestionResult = await testAttemptApi.skipQuestion(
      getters.testAttemptDetails.testAttemptId,
      getters.testAttemptDetails.currentQuestionId
    );
    dispatch("clearBusy");
    return skipQuestionResult;
  },
  async getSkippedQuestion({ commit, getters, dispatch }) {
    dispatch("setBusy");
    const questionDetails = await testAttemptApi.getSkippedQuestion(
      getters.testAttemptDetails.testAttemptId,
      getters.testAttemptDetails.currentQuestionId,
      getters.selectedLocaleId
    );
    console.log(questionDetails);

    if (!questionDetails) {
      throw consts.ERRORS.NO_SKIPPED_QUESTIONS;
    }

    commit("SET_QUESTION_NUMBER", questionDetails.questionNumber);
    commit("SET_QUESTION_DETAILS", questionDetails);

    dispatch("clearBusy");
  },
  async completeTest({ commit, getters, dispatch }) {
    dispatch("setBusy");

    const testAttempt = await testAttemptApi.completeTest(
      getters.testAttemptDetails.testAttemptId
    );

    let testAttempts = await testAttemptApi.getSessionTestAttempts(
      testAttempt.testAttemptId
    );

    commit("SET_TEST_ATTEMPTS", testAttempts);
    commit("SET_TEST_ATTEMPT", testAttempt);

    dispatch("clearBusy");

    //Add code to check if page is enabled//
    let nextPage = getters.pages.TestScoreCard.name;
    if (getters.displayTestReview) {
      nextPage = getters.pages.TestQuestionSummary.name;
    }
    dispatch("SetPage", nextPage);
  },
  setQuestionNumber({ commit }, questionNumber) {
    commit("SET_QUESTION_NUMBER", questionNumber);
  },
  setTestInstructionsDisplayed({ commit }, value) {
    commit("SET_TEST_INSTRUCTIONS_DISPLAYED", value);
  },
  async getTestQuestionSummary({ getters }) {
    const questionSummary = await testAttemptApi.getTestQuestionSummary(
      getters.testAttemptDetails.testAttemptId,
      getters.selectedLocaleId
    );
    return questionSummary;
  },
  setStartPage({ commit, getters }) {
    const page = determineStartPage(
      getters.testAttemptDetails.currentTestStage,
      getters.pages
    );
    commit("SET_PAGE", page);
  },
  async getTestStatus({ dispatch }, testAttemptId) {
    dispatch("setBusy");
    const status = await testAttemptApi.getTestAttemptStatus(testAttemptId);
    dispatch("clearBusy");
    return status;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
